var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3828 4.11719C18.8711 4.60547 18.8711 5.39844 18.3828 5.88672L8.38281 15.8867C7.89453 16.375 7.10156 16.375 6.61328 15.8867L1.61328 10.8867C1.125 10.3984 1.125 9.60547 1.61328 9.11719C2.10156 8.62891 2.89453 8.62891 3.38281 9.11719L7.5 13.2305L16.6172 4.11719C17.1055 3.62891 17.8984 3.62891 18.3867 4.11719H18.3828Z",
    fill: "#54ff99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8e4377039c5b1192a0c8d0e3375acb8c.svg";
export { ForwardRef as ReactComponent };